import ShowBundle from './show_bundle';

export default ShowBundle;
